// src/games/quiz/quizGroqService.js
// Question generation runs behind the `generateQuizQuestions` Cloud Function so the
// Groq API key stays server-side (Functions secret GROQ_API_KEY). Falls back to the
// built-in question bank on any error.

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { getFallbackQuestions } from './quizFallbackBank';

export async function generateQuizQuestions(topic, count = 8) {
  try {
    const result = await httpsCallable(functions, 'generateQuizQuestions')({ topic, count });
    const questions = result.data?.questions || [];
    if (questions.length >= count) return questions.slice(0, count);
    if (questions.length === 0) return getFallbackQuestions(topic, count);
    // Top up from fallback if the server returned fewer than requested
    return [...questions, ...getFallbackQuestions(topic, count - questions.length)].slice(0, count);
  } catch (err) {
    console.warn('Quiz generation unavailable, using built-in bank:', err.message);
    return getFallbackQuestions(topic, count);
  }
}